import React, { useEffect, useState } from 'react';
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState('');
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const nextSaturday = new Date();
      // Calculate days until next Saturday (day 6)
      const daysUntilSaturday = (6 - now.getDay() + 7) % 7;
      nextSaturday.setDate(now.getDate() + daysUntilSaturday);
      // If today is Saturday and it's past 12 PM, set to next Saturday
      if (now.getDay() === 6 && now.getHours() >= 12) {
        nextSaturday.setDate(now.getDate() + 7);
      }
      nextSaturday.setHours(12, 0, 0, 0);
      const difference = nextSaturday.getTime() - now.getTime();
      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(difference / (1000 * 60 * 60) % 24);
        const minutes = Math.floor(difference / 1000 / 60 % 60);
        const seconds = Math.floor(difference / 1000 % 60);
        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
      }
      return '0d 0h 0m 0s';
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-brand-purple text-white text-center py-2.5 px-4 text-sm font-medium tracking-wide z-50 relative" data-id="element-10">
      🚨 MENU CLOSES SATURDAY 12PM EST — {timeLeft}
    </div>;
}